
export default {
  name: 'PagesNavigatorProductHeader',
  data() {
    return {
      filterMenu: [
        {
          id: 1,
          title: 'Популярные',
          path: '/navigator/products',
          sub: () => null,
        },
        {
          id: 2,
          title: 'Новые',
          path: '/navigator/products/new',
          sub: () => null,
        },
        {
          id: 3,
          title: 'Есть акции',
          path: '/navigator/products/offers',
          sub: () => null,
        },
      ],
      lead: {
        title: 'Заказать обзор сервиса',
        description:
          'Наш специалист свяжется с вами и ответит на все ваши вопросы',
        data: {
          title: 'Пользователь хочет заказать обзор продукта',
          to: 'forbusiness',
          type: 'CALL',
          level: 'BUSINESS',
          body: null,
          source: {
            position:
              'Окно при клике на кнопке "Заказать обзор" в разделе "Обзор сервисов"',
            chapter: 'Обзоры',
            source: this.$route.path,
          },
        },
      },
    }
  },

  mounted() {
    this.$header.setVisibleAdditionalMenu(false)
    this.$header.setAdditionalMenu(null)

    this.$header.setAdditionalMenu({
      logo: null,
      title: 'Обзоры',
      menu: this.filterMenu,
    })
  },
  beforeDestroy() {
    this.$header.setVisibleAdditionalMenu(false)
    this.$header.setAdditionalMenu(null)
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll(_event, el) {
      if (el) {
        const { bottom } = el.getBoundingClientRect()

        if (bottom < 0) {
          this.$header.setVisibleAdditionalMenu(true)
        } else {
          this.$header.setVisibleAdditionalMenu(false)
        }
      }
    },
    sendLid() {
      this.$refs.leadForm.open()
    },
  },
}
